/**
 * Órdenes entregadas (`status=entregado`, historial). Reemplaza el placeholder de
 * `ROUTES.ordersDelivered`. Equivale a `delivered_orders.html` del SSR.
 */
import { OrdersListScreen } from "./OrdersListScreen";

export function OrdersDeliveredScreen() {
  return <OrdersListScreen status="entregado" title="Órdenes entregadas" />;
}
